

/// <reference path="ProxyPaymentTransaction.ts" />

// Generated class DLProxyPaymentTransaction_ManagedObject

class DLProxyPaymentTransaction_ManagedObject extends ProxyPaymentTransaction
{

    // Property: netAmount
    set netAmount(value:number) {
        this.setValueForKey(value, 'netAmount');
    }
    get netAmount():number {
        return this.valueForKey('netAmount');
    }
    set netAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'netAmount');
    }
    get netAmountPrimitiveValue():number {
        return this.primitiveValueForKey('netAmount');
    }

    // Property: schemaCashDeskSessionID
    set schemaCashDeskSessionID(value:string) {
        this.setValueForKey(value, 'schemaCashDeskSessionID');
    }
    get schemaCashDeskSessionID():string {
        return this.valueForKey('schemaCashDeskSessionID');
    }
    set schemaCashDeskSessionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'schemaCashDeskSessionID');
    }
    get schemaCashDeskSessionIDPrimitiveValue():string {
        return this.primitiveValueForKey('schemaCashDeskSessionID');
    }
}
